<template xmlns="http://www.w3.org/1999/html">
    <tbody>
        <tr class="userrow" @click="expanded = !expanded">
            <UserCell :removeOption="removeOption" :projectId="projectId" :userId="userId"></UserCell>
            <td v-if="!projectPlanning" v-for="(logged, dateIndex) in logs.total" :class="[dateIndex == actualDate ? 'curweek' : '', dateIndex > actualDate ? 'after-curweek' : '', dateIndex < actualDate ? 'before-curweek' : '']" class="text-right text-monospace">
                <div :class="{'zero-value': !logged.time}" v-show="showHours">{{Math.round(logged.time/3600)}}</div>
                <div v-show="showRateTime" :class="{'zero-value': !logged.expenses}" class="currency">{{Math.round(logged.expenses/3600)}}</div>
                <WorkloadPlanningCell v-if="showTotalPlanned" :plannedWorkload="plannedWorkloads[userId] && plannedWorkloads[userId][dateIndex] ? plannedWorkloads[userId][dateIndex] : totalPlanned" :userId="userId" :dateIndex="dateIndex" :projectId="projectId" :showWorkloadPlanner="showWorkloadPlanner" :showPlannedExpenses="showPlannedExpenses" :showTotalPlanned="showTotalPlanned" :timeframe="timeframe"></WorkloadPlanningCell>
            </td>
            <td v-if="projectPlanning" v-for="(logged, dateIndex) in logs.total" :class="[dateIndex == actualDate ? 'curweek' : '', dateIndex > actualDate ? 'after-curweek' : '', dateIndex < actualDate ? 'before-curweek' : '']" class="text-right text-monospace">
                <div class="logged-number" v-if="dateIndex < actualDate" v-show="showHours">{{(logged.time/3600).toFixed(2)}}</div>
                <WorkloadPlanningCell :projectPlanning="projectPlanning" :plannedWorkload="plannedWorkloads[userId] && plannedWorkloads[userId][dateIndex] ? plannedWorkloads[userId][dateIndex] : totalPlanned" v-if="showTotalPlanned" :userId="userId" :dateIndex="dateIndex" :projectId="projectId" :showWorkloadPlanner="showWorkloadPlanner" :showPlannedExpenses="showPlannedExpenses" :showTotalPlanned="showTotalPlanned" :timeframe="timeframe"></WorkloadPlanningCell>
            </td>
        </tr>
        <tr class="userrow projects" v-if="allowExpanding && expanded" v-for="(logged, projectId) in logs.byProject">
            <ProjectCell :projectId="projectId"></ProjectCell>
            <td v-if="!projectPlanning" v-for="(log, dateIndex) in logged" :class="[dateIndex == actualDate ? 'curweek' : '', dateIndex > actualDate ? 'after-curweek' : '', dateIndex < actualDate ? 'before-curweek' : '']" class="text-right text-monospace">
                <div :class="{'zero-value': !log.time}" v-show="showHours">{{(log.time/3600).toFixed(0)}}</div>
                <div v-show="showRateTime" :class="{'zero-value': !log.expenses}" class="currency">{{(log.expenses/3600).toFixed(0)}}</div>
                <WorkloadPlanningCell v-if="showTotalPlanned" :plannedWorkload="plannedWorkloads[userId] && plannedWorkloads[userId][dateIndex] ? plannedWorkloads[userId][dateIndex] : totalPlanned" :userId="userId" :dateIndex="dateIndex" :projectId="projectId" :showWorkloadPlanner="showTotalPlanned" :showPlannedExpenses="showPlannedExpenses" :showTotalPlanned="false" :timeframe="timeframe"></WorkloadPlanningCell>
            </td>
            <td v-if="projectPlanning" v-for="(logged, dateIndex) in logged" :class="[dateIndex == actualDate ? 'curweek' : '', dateIndex > actualDate ? 'after-curweek' : '', dateIndex < actualDate ? 'before-curweek' : '']" class="text-right text-monospace">
                <div class="logged-number" v-if="dateIndex < actualDate" v-show="showHours">{{(logged.time/3600).toFixed(2)}}</div>
                <WorkloadPlanningCell :projectPlanning="projectPlanning" :plannedWorkload="plannedWorkloads[userId] && plannedWorkloads[userId][dateIndex] ? plannedWorkloads[userId][dateIndex] : totalPlanned" v-if="showTotalPlanned" :userId="userId" :dateIndex="dateIndex" :projectId="projectId" :showWorkloadPlanner="showWorkloadPlanner" :showPlannedExpenses="showPlannedExpenses" :showTotalPlanned="showTotalPlanned" :timeframe="timeframe"></WorkloadPlanningCell>
            </td>
        </tr>
    </tbody>
</template>
<script>

import { mapGetters, mapActions, mapState } from 'vuex';
import UserCell from './UserCell';
import ProjectCell from './ProjectCell';
import WorkloadPlanningCell from './WorkloadPlanningCell';

export default {
  name: 'UserRow',
  props: [
    'userId',
    'projectId',
    'logs',
    'showRateTime',
    'showHours',
    'showWorkloadPlanner',
    'showPlannedExpenses',
    'showTotalPlanned',
    'allowExpanding',
    'timeframe',
    'projectPlanning',
    'plannedWorkloads',
    'removeOption'
  ],
  data: function () {
    return {
      expanded: false,
      totalPlanned: {
        totalPlanned: 0,
        totalCalculated: 0,
        projects: null
      }
    };
  },
  components: {
    UserCell,
    WorkloadPlanningCell,
    ProjectCell
  },
  computed: {
    ...mapGetters('Worklogs', ['curweek', 'actualDate']),
  },
  methods: {
            
  },
  mounted() {

  },
};
</script>
<style scoped>
    td {
        padding: 0.1rem;
        border-right: 1px solid #cfd8dc;
    }
    .currency::after{
        content: "€";
    }
    .curweek {
        background-color: #ffffff;
        border-left: 3px solid black;
    }
    .before-curweek {
        background-color: #ffffff;
    }
    .after-curweek {
        background-color: #ffffff;
    }
    .logged-number {
        font-weight:bold;
        color: crimson;
    }
    .table-data{
        /*text-align: right;*/
    }
    .zero-value{
        color: silver;
    }
    .userrow {
        border-left: 3px solid;
    }
    .userrow:hover {
        background-color: #efefef
    }
    .userrow .first-column {
        background-color: #e4e5e6;
        padding-left: 1rem;
    }
    .userrow td {
        background-color: #e4e5e6;
        padding-right: 0.3rem;
    }
    .projects {
        background-color: #f7f7f7;
    }
    tbody{
        border-top: none !important;
    }
</style>
